import { CryptoNetworkConfig } from 'core/models/app-config/network/app-config-network.model';
import { create } from 'zustand';

type State = {
  cryptoNetworks: CryptoNetworkConfig[];
};

type Action = {
  setCryptoNetworks: (networks: CryptoNetworkConfig[]) => void;
};

const useGlobalStore = create<State & Action>((set) => ({
  cryptoNetworks: [],
  setCryptoNetworks: (networks) =>
    set((state) => ({ ...state, cryptoNetworks: networks })),
}));

export default useGlobalStore;
